module.exports = __webpack_public_path__ + "static/media/dj.2cea5300.webp";